import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useI18n } from "@/i18n";
import { useAuth } from "@/AuthContext";

const IMG = "https://images.unsplash.com/photo-1597251000118-e702d0828392?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Auth() {
  const { t } = useI18n();
  const { user, login, register } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav("/"); }, [user]); // eslint-disable-line

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "login") await login(form.email, form.password);
      else await register(form.name, form.email, form.password);
      toast.success("Bienvenue");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={IMG} alt="" className="absolute inset-0 w-full h-full object-cover grayscale" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] to-black/30" />
        <div className="absolute bottom-12 left-12">
          <div className="font-clash font-bold text-3xl uppercase">Hors<span className="text-[#BC5D2E]">Signal</span></div>
          <p className="font-mono-hs text-xs text-[#A3A3A3] uppercase tracking-widest mt-2">{t("footer_tag")}</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 sm:px-12 py-32">
        <div className="w-full max-w-sm">
          <h1 className="font-clash font-bold text-4xl uppercase tracking-tighter">{mode === "login" ? t("login_title") : t("reg_title")}</h1>
          <form onSubmit={submit} className="mt-10 space-y-6" data-testid="auth-form">
            {mode === "register" && (
              <input required placeholder={t("your_name")} value={form.name} onChange={set("name")} className="hs-input" data-testid="auth-name" />
            )}
            <input required type="email" placeholder={t("your_email")} value={form.email} onChange={set("email")} className="hs-input" data-testid="auth-email" />
            <input required type="password" placeholder="••••••••" value={form.password} onChange={set("password")} className="hs-input" data-testid="auth-password" />
            <button disabled={busy} className="w-full bg-[#BC5D2E] text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#8A281E] transition-colors disabled:opacity-50" data-testid="auth-submit">
              {busy ? "..." : mode === "login" ? t("login") : t("reg_title")}
            </button>
          </form>
          <div className="flex items-center gap-4 my-6">
            <div className="flex-1 h-px bg-white/10" /><span className="font-mono-hs text-[10px] text-[#737373] uppercase">ou</span><div className="flex-1 h-px bg-white/10" />
          </div>
          <button onClick={google} className="w-full border border-white/30 px-8 py-4 uppercase tracking-widest text-sm hover:border-white transition-colors" data-testid="auth-google">
            {t("or_google")}
          </button>
          <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="w-full text-center mt-8 text-xs uppercase tracking-widest text-[#A3A3A3] hover:text-white" data-testid="auth-switch">
            {mode === "login" ? t("no_account") : t("have_account")}
          </button>
        </div>
      </div>
    </div>
  );
}
